import { IsOptional } from 'class-validator';

export class OrderAuctionUpdateModel {
  @IsOptional()
  public pickupAddressId?: string | null;
}
